<div
  class="modal show d-block"
  id="assignDoctorModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "doctorAssignModal.assignDoctor" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="activeModal.dismiss()"
        ></button>
      </div>

      <div class="modal-body" style="overflow: visible;">
        <ng-container *ngIf="organizationId; else listTemplate">
          <div class="mb-3">
            <label for="doctorSelect" class="form-label">{{
              "doctorAssignModal.selectDoctor" | translate
            }}</label>
            <app-select
              [items]="WoundForApproveDto?.wound?.assignDoctors"
              bindLabel="doctorName"
              bindValue="doctorId"
              [placeholder]="
                selectedDoctorId
                  ? ''
                  : 'doctorAssignModal.selectDoctorPlaceholder' | translate
              "
              [(ngModel)]="selectedDoctorId"
              (ngModelChange)="onDoctorSelectChange($event)"
            ></app-select>
          </div>
        </ng-container>

        <ng-template #listTemplate>
          <div class="list-group">
            <button
              type="button"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              *ngFor="let doctor of WoundForApproveDto?.wound?.assignDoctors"
              [class.active]="selectedDoctorId === doctor.doctorId"
              (click)="selectDoctor(doctor.doctorId, doctor.doctorName)"
            >
              <div>
                <div class="fw-semibold">{{ doctor.doctorName }}</div>
                <small class="text-muted"></small>
              </div>

              <i
                class="bi bi-check-circle-fill"
                *ngIf="selectedDoctorId === doctor.doctorId"
              ></i>
            </button>
          </div>
        </ng-template>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="activeModal.dismiss()">
          {{ "doctorAssignModal.cancel" | translate }}
        </button>

        <button
          class="btn btn-primary"
          [disabled]="!selectedDoctorId"
          (click)="assignDoctor()"
        >
          {{ "doctorAssignModal.assign" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
